(function () {
    "use strict";

    angular
        .module('iMatApp')
        .directive('onOffSwitcher', onOffSwitcherDirective);

    function onOffSwitcherDirective() {
        var directive = {
            compile: compile,
            templateUrl: '/Scripts/iMatApp/views/onOffSwitcherTemplate.html',
            restrict: 'A',
            scope: {
                model: '=ngModel',
                onText: '@?',
                offText: '@?',
                titleText: '@?'
            }
        };

        return directive;

        // ----------------------------------------------------------------------------------

        function compile(element, attrs) {
            attrs.onText = attrs.onText || 'ON';
            attrs.offText = attrs.offText || 'OFF';
        }
    }
})();